<div class="gcontainer bwhite">
  <div class="row">
    <div class="col-md-12">
      <nav aria-label="breadcrumb" class="mt-8">
        <ol class="breadcrumb">
          <li
            class="breadcrumb-item active breadcrumb cursor"
            aria-current="page"
            (click)="reDirectUrl()"
            (keypress)="reDirectUrl()"
            tabindex="0">
            Dashboard
          </li>
          <li class="breadcrumb-item active" aria-current="page">Search Mix ID</li>
        </ol>
      </nav>
      <h1 class="mat-h1">Mix ID : {{ mixDesignCode }}</h1>
    </div>
  </div>

  @if (errorMessage) {
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  }

  @if (!errorMessage) {
    <div class="row mt-4 flex-grow-1" style="min-height: 80vh;">
      <div class="col-md-6 pe-1">
        <mat-card class="pop-shadow-card full-height">
          <mat-card-content>
            <h3 class="mat-h3">Previous Thermal Results</h3>
            @if (dataSource.data.length <= 0) {
              <div class="row mt-4">
                <div class="col-md-12"><div class="alert alert-danger" role="alert">No records found.</div></div>
              </div>
            }
            @if (dataSource.data.length > 0) {
              <div class="table-wrapper">
                <table mat-table [dataSource]="groupedData" multiTemplateDataRows class="mat-mdc-table mat-elevation-z1">
                  <ng-container matColumnDef="combinedInfo">
                    <th mat-header-cell *matHeaderCellDef style="width: 98%;"> Info </th>
                    <td mat-cell *matCellDef="let group">
                      {{ group.firstItem.projectName }} - {{ group.firstItem.projectLocation || '[Project Location]'}} : {{ group.firstItem.companyName }}
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef style="width: 2%;"></th>
                    <td mat-cell *matCellDef="let group">
                      <div style="display: flex; justify-content: flex-end;">
                        <button mat-icon-button (click)="toggleGroup(group.groupIndex)">
                          <mat-icon>
                            {{ expandedGroups.includes(group.groupIndex) ? 'expand_less' : 'expand_more' }}
                          </mat-icon>
                        </button>
                      </div>
                    </td>
                  </ng-container>
                  <tr mat-row *matRowDef="let group; columns: displayedColumns;"></tr>
                  <tr mat-row *matRowDef="let group; columns: ['expandedDetail']" [hidden]="!expandedGroups.includes(group.groupIndex)"></tr>
                  <ng-container matColumnDef="expandedDetail">
                    <td mat-cell *matCellDef="let group" [attr.colspan]="displayedColumns.length">
                      <div class="expanded-container">
                        <table class="inner-table">
                          <thead>
                            <tr>
                              <th style="width: 32%;">Sample Id</th>
                              <th style="width: 15%;">Due Date</th>
                              <th style="width: 8%;">M/C</th>
                              <th style="width: 10%;">Density</th>
                              <th style="width: 10%;">Wet TR</th>
                              <th style="width: 15%;">Dry TR</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (sub of group.subGroups; track sub; let i = $index) {
                              @for (item of sub; track item) {
                                <tr
                                  [ngClass]="{ 'zebra-row': i % 2 === 1 }">
                                  <td>
                                    <a (click)="openSample(item)" class="sample-link">
                                      {{ item.sampleId }}
                                    </a>
                                  </td>
                                  <td>{{ formatDate(item.dueDate) }}</td>
                                  <td>{{ item.averageMoisture }}</td>
                                  <td>{{ item.averageDensity }}</td>
                                  <td>{{ item.averageWetTr }}</td>
                                  <td>{{ item.averageDryTr }}</td>
                                </tr>
                              }
                            }
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </ng-container>
                </table>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </div>
      <div class="col-md-6 ps-3">
        <mat-card class="pop-shadow-card full-height">
          <mat-card-content>
            <h3 class="mat-h3">Mix Designs</h3>
            <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
              @for (mixDesign of mixDesigns; track mixDesign; let i = $index) {
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span
                      class="tab-label"
                  [ngClass]="{
                    'reference-tab': mixDesign.isReference,
                    'highlight-tab': hasQueryMixReference && mixDesign.mixReferenceId?.toString() === originalMixReference
                  }">
                      @if (mixDesign.isReference) {
                        <span class="reference-text">Geotherm</span>
                      }
                      @if (!mixDesign.isReference) {
                        <span class="reference-text">Client</span>
                      }
                      <span class="mix-id">{{ mixDesign.mixId }}</span>
                      <span class="mix-reference">{{ mixDesign.mixReferenceId }}</span>
                      <span class="mix-id-date">{{ mixDesign.date ? formatDate(mixDesign.date) : '\u00A0' }}</span>
                    </span>
                  </ng-template>
                  <div class="tab-content">
                    <p class="mat-tab-description">{{ mixDesign.description }}</p>
                    <table class="mat-mdc-table mat-elevation-z1 info-table">
                      <tbody>
                        <tr>
                          <td class="key">Company Name</td>
                          <td>{{ mixDesign.companyName }}</td>
                          <td class="key">Water / Cement Ratio</td>
                          <td><b>{{ getWaterCementRatio(mixDesign.items) }}</b></td>
                        </tr>
                        <tr>
                          <td class="key">Project Name</td>
                          <td>{{ mixDesign.projectName }}</td>
                          <td class="key">Moisture Content</td>
                          <td><b>{{ getMoistureContent(mixDesign.items) }}%</b></td>
                        </tr>
                        <tr>
                          <td class="key">Material Type</td>
                          <td>{{ mixDesign.materialType }}</td>
                          <td class="key">Dry Density <span class="unit-text">(lb/yd³)</span></td>
                          <td><b>{{ getDryDensity(mixDesign.items) }}</b></td>
                        </tr>
                        <tr>
                          <td class="key">Strength <span class="unit-text">(psi)</span></td>
                          <td>{{ mixDesign.strength }}</td>
                          <td class="key">Slump <span class="unit-text">(inches)</span></td>
                          <td>{{ mixDesign.slump }}</td>
                        </tr>
                        <tr>
                          <td class="key">City</td>
                          <td>{{ mixDesign.city }}</td>
                          <td class="key">State</td>
                          <td>{{ mixDesign.state }}</td>
                        </tr>
                        <tr>
                          <td class="key">Mix Designed Date</td>
                          <td>{{ formatDate(mixDesign.date) }}</td>
                          <td class="key">Created Date</td>
                          <td>{{ formatDate(mixDesign.createdAt) }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="header-row">
                      <h3 class="mat-h3">Component Materials</h3>
                      <button mat-raised-button color="primary" (click)="openEditMixDesign(mixDesign)">
                        Edit Mix Design
                      </button>
                    </div>
                    <div class="table-scroll-container">
                      <table mat-table [dataSource]="mixDesign.items" class="mat-mdc-table mat-elevation-z1">
                        <ng-container matColumnDef="materialType">
                          <th mat-header-cell *matHeaderCellDef style="width: 18%;">Material Type</th>
                          <td mat-cell *matCellDef="let item">{{ item.materialType }}</td>
                        </ng-container>
                        <ng-container matColumnDef="supplier">
                          <th mat-header-cell *matHeaderCellDef style="width: 22%;">Supplier Name</th>
                          <td mat-cell *matCellDef="let item">{{ item.supplier }}</td>
                        </ng-container>
                        <ng-container matColumnDef="description">
                          <th mat-header-cell *matHeaderCellDef style="width: 22%;">Supplier Material Name</th>
                          <td mat-cell *matCellDef="let item">{{ item.description }}</td>
                        </ng-container>
                        <ng-container matColumnDef="weight">
                          <th mat-header-cell *matHeaderCellDef style="width: 18%;">Dry Weight<span class="unit-text"> (lb/yd³)</span></th>
                          <td mat-cell *matCellDef="let item" class="weight-cell">
                            {{ item.weight }}<span class="unit-text">{{ item.materialType === 'Add Mixer' ? ' oz/yd³' : '' }}</span>
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="gravity">
                          <th mat-header-cell *matHeaderCellDef style="width: 18%;">Specific Gravity</th>
                          <td mat-cell *matCellDef="let item" class="weight-cell">{{ item.gravity }}</td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="['materialType', 'supplier', 'description', 'weight', 'gravity']"></tr>
                        <tr mat-row *matRowDef="let row; columns: ['materialType', 'supplier', 'description', 'weight', 'gravity'];"></tr>
                      </table>
                    </div>
                  </div>
                </mat-tab>
              }
            </mat-tab-group>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  }
</div>
